<template>
  <div class="noticeDetail full-height relative">
    <ld-header>{{ $t('A138','消息详情') }}</ld-header>

    <div class="pad20">
      <h3>{{ notice.tzTitle }}</h3>
      <pre class="pre-wrap gray">
        {{ notice.content }}
      </pre>
    </div>
    <ld-tabbar style="padding:0 10px;">
      <van-row class="full-width">
        <van-col span="6" />
        <van-col span="12">
          <ld-button
            v-if="notice.status === 0"
            defaults
            round
            size="md"
            @click="read"
          >
            我知道了
          </ld-button>
          <ld-button
            v-else
            defaults
            round
            size="md"
            @click="read"
          >
            关闭
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Popup } from 'vant'
import ldButton from 'Common/ldButton'
import NoticeInteractor from '@/business/Domain/use-cases/notice-interactor'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
 
export default {
  name: 'NoticeDetail',
  components: {
    [Popup.name]: Popup,
    ldButton,
    ldTabbar
  },
  data() {
    return {
      notice: {}
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  async created () {
    if(this.id){
      const { data } = await NoticeInteractor.getNoticeById(this.id)

      this.notice = data
    }
  },
  methods: {
    ...mapActions(['readNotice']),
    read () {
      this.readNotice(this.id)
      NoticeInteractor.readNotice(this.id)
      this.$router.go(-1)
    }
  },
}
</script>

<style lang="less">
.noticeDetail {
  background: #fff;

  h3 {
    margin: 5px 0;
  }

  .pad20 {
    padding: 20px;
  }

}
</style>